const MSMBADetail = () => (
  <div className="container my-5">
    <h2>MBA - Management Information Systems.</h2>
    <p>The MBA with a concentration in Management Information Systems includes courses focused on 
        providing students with the knowledge, skills and abilities needed for effective management in 
        today's technological world.  Students will be equipped with a working command of current 
        informational practices that can immediately be applied in business, educational, and governmental organizations.</p>
  
  <h2>MS - IST(Web Development)</h2>
  <p>Provides and advance the knowledge, skills, and abilities needed by perspective and current 
    Information Technology (IT) professionals for managing information systems. Students completing 
    the program will obtain a better understanding of the relationship between business requirements and 
    technology solutions with an emphasis on applying a systems approach when integrating 
    information technology into strategic business/education/government activities.</p>
</div>
);

export default MSMBADetail;